import { Component, OnDestroy, OnInit } from '@angular/core';
import { get } from 'lodash';
import { Subscription } from 'rxjs';
import { HeaderService } from 'src/app/services/header.service';
import { AcknowledgmentMessage, AcknowledgmentTitle } from 'src/app/shared/constants';
import { environment } from '../../../environments/environment';
import { AcknowledgmentInfo, FormService } from '../form.service';

@Component({
  selector: 'app-acknowledgment-screen',
  templateUrl: './acknowledgment-screen.component.html',
  styleUrls: ['./acknowledgment-screen.component.scss']
})
export class AcknowledgmentScreenComponent implements OnInit, OnDestroy {
  assetPath = environment.assetPath;

  title = AcknowledgmentTitle;
  message = AcknowledgmentMessage;
  private subscriptions: Subscription = new Subscription();
  constructor(
    private formService: FormService,
    private headerService: HeaderService
  ) { }

  ngOnInit() {
    this.headerService.setTitle('Form submitted');
    this.subscriptions.add(this.formService.acknowledgmentScreenInfo.subscribe((value: AcknowledgmentInfo) => {
      this.title = get(value, 'title', '') ? get(value, 'title', '') : this.title;
      this.message = get(value, 'message', '') ? get(value, 'message', '') : this.message;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
